// Module
var code = "<react-component name=\"DebtorsReport\"></react-component>\n";
// Exports
module.exports = code;